<span matDialogTitle>{{ 'Conferma operazione' | siaTranslate }}</span>
<button mat-icon-button matDialogClose (click)="onNoClick()">
  <mat-icon> close </mat-icon>
</button>
<mat-dialog-content>
  <div class="flex justify-start w-full">
    <span [innerHTML]="messageHtml()"></span>
  </div>
  <mat-form-field appearance="fill" class="w-full mt-4">
    <mat-label>{{ label() | siaTranslate }}</mat-label>
    <input
      matInput
      type="text"
      [ngModel]="value()"
      (ngModelChange)="onValueChange($event)"
      required
    />
    @if (showValidationError()) {
      <mat-error>
        {{ errorMessage() | siaTranslate }}
      </mat-error>
    }
  </mat-form-field>
</mat-dialog-content>
<div matDialogActions align="end">
  <button
    mat-button
    (click)="onYesClick()"
    [autofocus]="true"
    [disabled]="isValueInvalid()"
  >
    {{ yesLabel() | siaTranslate }}
  </button>
  <button mat-button (click)="onNoClick()" class="error">
    {{ noLabel() | siaTranslate }}
  </button>
</div>
